import { ReportEmpty } from '../reports/body'

export default function NoContent({ data, noDataIndication }) {
  if (data && data.length) {
    return null
  }

  return <>
    <div className='w-full flex opacity-0 h-10'>
      No content to show
    </div>
    <ReportEmpty>
      <div className='w-full flex items-center justify-center p-6 absolute top-8 left-1/2 -translate-x-1/2'>
        {noDataIndication ? noDataIndication() : 'No content to show.'}
      </div>
    </ReportEmpty>
  </>
}
